export enum EItemReason {
  RANKED = "ranked",
  SKIN = "skin",
  PRODUCT = "product",
}
